import { Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

const BackButton = ({ text }) => {
  const navigate = useNavigate();

  return (
    <Box
      onClick={() => navigate(-1)}
      sx={{
        color: "#344492",
        cursor: "pointer",
        fontWeight: 500,
        border: "1px solid #344492",
        display: "inline-block",
        padding: "4px 8px", // ← for spacing inside the border
        borderRadius: "4px",
        mb: 2,
        width: "fit-content",
        "&:hover": {
          textDecoration: "underline",
        },
      }}
    >
      {text}
    </Box>
  );
};

BackButton.propTypes = {
  text: PropTypes.string.isRequired,
};

export default BackButton;
